import * as React from 'react';
import { Col, Row, Modal } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { TaxonomyTags } from 'src/app/general/taxonomies/form/parts/taxonomy-tags';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { TaskStateEditorView } from 'src/app/general/user-tasks/parts/task-state.editor';
import { TextView } from 'src/core/ui/text.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { resolve } from 'inversify-react';
import { IdentityService } from 'src/core/services/identity.service';
import * as Permissions from '../../../permissions';

interface Props extends ComponentViewProps<UserTaskItem> {
	title: string;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	onSave: () => Promise<void>;
	onCancel: () => Promise<boolean>;
	defaultLanguage: string;
	contextService: any;
	isNew: boolean;
	visible: boolean;
	working: boolean;
}

@observer
export class UserTaskFormView extends React.Component<Props, {}> {

	@resolve
	identityService: IdentityService;

	private isAuthorized(permissions: string[]): boolean {
		return permissions.some(m => this.identityService.isAuthorized(m));
	}

	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			title, mode, onModeChange, onSave, onCancel,
			model, setBusy, defaultLanguage
		} = this.props;

		var modeWorking = this.props.working ? 'display' : mode;

		const canChangeAssignment = this.isAuthorized(Permissions.userTaskWriteAssignment);
		const canChangeDeadline = this.isAuthorized(Permissions.userTaskWriteDeadline);
		const canChangeStatus = this.isAuthorized(Permissions.userTaskWriteStatus);
		const canChangeTitle = this.isAuthorized(Permissions.userTaskWriteTitle);
		const canChangeBody = this.isAuthorized(Permissions.userTaskWriteBody);
		const canChangePriority = this.isAuthorized(Permissions.userTaskWritePriority)

		return (
			<div>
				<Modal
					width={600}
					title={"Add/Edit User task"}
					visible={this.props.visible}
					onOk={this.props.onSave}
					onCancel={this.props.onCancel}
				>
					<Row gutter={24}>
						<Col xs={6}>
							<UserEditorController
								label="Assigned to"
								value={model.assignedToId}
								mode={canChangeAssignment? modeWorking: 'display'}
								required
								isRole={undefined}
								setBusy={this.props.setBusy}
								onChanged={e => model.assignedToId = e ? e.id : undefined}
							/>
						</Col>
						<Col xs={6}>
							<DateView
								label="Deadline"
								value={model.deadline}
								required
								showTime
								format={'date-time'}
								mode={canChangeDeadline ? modeWorking : 'display'}
								onChanged={e => model.deadline = e}
							/>
						</Col>
						<Col xs={6}>
							<TaskStateEditorView
								label="Task status"
								required
								value={model.status}
								isNew={this.props.isNew}
								mode={canChangeStatus ? modeWorking : 'display'}
								onChanged={e => model.status = e}
							/>
						</Col>
						<Col xs={6}>
							<TextView
								label="Priority"
								required
								type='number'
								value={model.priority}
								mode={canChangePriority ? modeWorking : 'display'}
								onChanged={e => model.priority = e}
							/>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col xs={24}>
							<TextView
								label="Title"
								required
								value={model.title}
								mode={canChangeTitle ? modeWorking : 'display'}
								onChanged={e => model.title = e}
							/>
						</Col>
						
					</Row>
					<Row gutter={24}>
						<Col xs={24}>
							<RichTextView
								containerClassName="wysiwyg-editor-wrap-content"
								label="Body"
								
								value={model.body}
								onChanged={(html) => {
									model.body = html;
								}}
								mode={canChangeBody ? modeWorking : 'display'}
							/>
						</Col>
					</Row>
					{!this.props.isNew && <Row gutter={24}>
						<Col xs={24}>
							<TextView
								label="Change reason"
								required
								value={model.changeReason}
								mode={'edit'}
								rows={5}
								onChanged={e => model.changeReason = e}
							/>
						</Col>

					</Row>}
				</Modal>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/form/user-task.view.tsx